import React from 'react';
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import i18n from 'i18next';

const SimpleConfirmModal = ({
  header = i18n.t('features.EmployeePays.components.RollbackEmployeePayModal.Operation_confirmation'),
  isOpen,
  hideModal,
  body,
  onClick,
  cancelBtnText = i18n.t('features.EmployeeBonus.components.ConfirmBonusModal.Cancel'),
  confirmBtnText = i18n.t('features.EmployeeBonus.components.ConfirmBonusModal.Confirm')
}) => (
  <CommonModal header={header} isOpen={isOpen} hideModal={hideModal} ariaHideApp={false}>
    <CommonModal.Header hideModal={hideModal}>{header}</CommonModal.Header>
    <CommonModal.Body>{body}</CommonModal.Body>
    <CommonModal.Footer>
      <Button onClick={hideModal} className="u-mr20">
        {cancelBtnText}
      </Button>
      <Button onClick={onClick} primary>
        {confirmBtnText}
      </Button>
    </CommonModal.Footer>
  </CommonModal>
);

export default SimpleConfirmModal;
